import { useTranslation } from 'react-i18next';

import { ReactComponent as GlobalIcon } from '@work4all/assets/icons/m-bubble.svg';

import { Tooltip } from '../components/tooltip/Tooltip';

const TenantChangeIcon = () => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('COMMON.INPUT_TENANT_ICON')}>
      <GlobalIcon />
    </Tooltip>
  );
};

export default TenantChangeIcon;
